import { Auth } from 'aws-amplify';
import Locker from 'lockr';
//TODO send the Locker token here. We can piggy back on this when we are working on auth logic. (Discuss with Arnav)

const setTenantSlug = (tenantSlug) => {
  console.log(
    'Slug trace',
    'Setting tenant slug in local storage.',
    tenantSlug,
  );

  Locker.set('tenantSlug', tenantSlug);
};
const getTenantSlug = () => {
  return Locker.get('tenantSlug');
};
const removeTenantSlug = () => {
  console.log('Slug trace', 'Removing tenant slug from local storage.');

  // ##TODO, don't remove token from local storage. We need to keep it for the time being.
  // Locker.rm('tenantSlug');
};

const setToken = (token) => Locker.set('token', token);
const getToken = () => Locker.get('token');

const setEmail = (email) => Locker.set('email', email);
const getEmail = () => Locker.get('email');

const isAuthenticated = () => !!Locker.get('token');

const setIsGoogleAuth = () => Locker.set('isGoogleAuth', 'true');
const isGoogleAuth = () => Locker.get('isGoogleAuth') === 'true';

const setIsInvalidSsoIdpTokenViaGoogle = () =>
  Locker.set('isInvalidSsoIdpTokenViaGoogle', true);
const getIsInvalidSsoIdpTokenViaGoogle = () =>
  Locker.get('isInvalidSsoIdpTokenViaGoogle');
const removeIsInvalidSsoIdpTokenViaGoogle = () =>
  Locker.rm('isInvalidSsoIdpTokenViaGoogle');

const setIsUnapprovedUser = () => Locker.set('isUnapprovedUserError', true);
const getIsUnapprovedUser = () => Locker.get('isUnapprovedUserError');
const removeIsUnapprovedUser = () => Locker.rm('isUnapprovedUserError');

const setIsSuspendedUser = () => Locker.set('isSuspendedUserError', true);
const getIsSuspendedUser = () => Locker.get('isSuspendedUserError');
const removeIsSuspendedUser = () => Locker.rm('isSuspendedUserError');

const setIsInviteCodeVerificationFailed = () =>
  Locker.set('isInviteTokenVerificationFailed', true);
const getIsInviteCodeVerificationFailed = () =>
  Locker.get('isInviteTokenVerificationFailed');
const removeIsInviteCodeVerificationFailed = () =>
  Locker.rm('isInviteTokenVerificationFailed');

const setIsNoAccessToClientApplication = () =>
  Locker.set('isNoAccessToClientApplication', true);
const getIsNoAccessToClientApplication = () =>
  Locker.get('isNoAccessToClientApplication');
const removeIsNoAccessToClientApplication = () =>
  Locker.rm('isNoAccessToClientApplication');

const setCustomAuthErrorMessage = (message) =>
  Locker.set('customAuthErrorMessage', message);
const getCustomAuthErrorMessage = () => Locker.get('customAuthErrorMessage');
const removeCustomAuthErrorMessage = () => Locker.rm('customAuthErrorMessage');

const setIsTrialExpired = () => Locker.set('isTrialExpired', true);
const getIsTrialExpired = () => Locker.get('isTrialExpired');
const removeIsTrialExpired = () => Locker.rm('isTrialExpired');

const refreshTokenIfRequired = () =>
  new Promise((resolve) => {
    Auth.currentSession()
      .then((session) => {
        const token = session?.idToken?.jwtToken;
        setToken(token);
        resolve();
      })
      .catch(() => {
        // This would happen if Auth is not able to refresh the session and threw
        // an error. In such case, go ahead with the request and handle
        // Unauthorised error in reponse
        resolve();
      });
  });

const AuthService = {
  setToken,
  isAuthenticated,
  setEmail,
  getEmail,
  getToken,
  refreshTokenIfRequired,
  isGoogleAuth,
  setIsGoogleAuth,
  setIsInvalidSsoIdpTokenViaGoogle,
  getIsInvalidSsoIdpTokenViaGoogle,
  removeIsInvalidSsoIdpTokenViaGoogle,
  setIsUnapprovedUser,
  getIsUnapprovedUser,
  removeIsUnapprovedUser,
  setIsSuspendedUser,
  getIsSuspendedUser,
  removeIsSuspendedUser,
  setIsInviteCodeVerificationFailed,
  getIsInviteCodeVerificationFailed,
  removeIsInviteCodeVerificationFailed,
  setIsNoAccessToClientApplication,
  getIsNoAccessToClientApplication,
  removeIsNoAccessToClientApplication,
  setCustomAuthErrorMessage,
  getCustomAuthErrorMessage,
  removeCustomAuthErrorMessage,
  setIsTrialExpired,
  getIsTrialExpired,
  removeIsTrialExpired,
  setTenantSlug,
  getTenantSlug,
  removeTenantSlug,
};

export default AuthService;
